import React from 'react';
import { FaShieldAlt, FaEye, FaBalanceScale, FaInfoCircle, FaFileAlt, FaAd, FaClock, FaVolumeUp, FaSignOutAlt, FaExclamationTriangle, FaWheelchair, FaComment, FaGavel, FaEnvelope, FaPhone, FaCertificate, FaMapMarkerAlt } from 'react-icons/fa';
import "../Assets/Styles/Pages/InvestorCharter_page.css"
import AboutNav from '../Components/Navigation/AboutNav';
import Footer from '../Components/Home/Footer';

const InvestorCharter_page = () => {
  return (
    <div className="investor-charter-page">
      {/* Navigation */}
      <AboutNav />
      
      {/* Hero Section */}
      <section className="charter-hero">
        <div className="charter-container">
          <div className="hero-content">
            <h1>Investor Charter</h1>
            <p>SEBI Registered Research Analyst - Trillion Stock Research</p>
            <div className="charter-badge">
              <span>SEBI Registration No: INH000020129</span>
            </div>
          </div>
        </div>
      </section>

      {/* Main Content */}
      <div className="charter-main">
        <div className="charter-container">
          
          {/* Vision & Mission */}
          <section className="charter-section">
            <h2>A. Vision and Mission Statements for Investors</h2>
            
            <div className="vision-mission-grid">
              <div className="vision-box">
                <h3>Vision</h3>
                <p>Invest with knowledge & safety.</p>
              </div>
              <div className="mission-box">
                <h3>Mission</h3>
                <p>Every investor should be able to invest in right investment products based on their needs, manage and monitor them to meet their goals, access reports and enjoy financial wellness.</p>
              </div>
            </div>
          </section>

          {/* Business Details */}
          <section className="charter-section">
            <h2>B. Details of Business Transacted by the Research Analyst</h2>
            <div className="business-list">
              <ul>
                <li>To publish research report based on the research activities of the RA</li>
                <li>To provide an independent unbiased view on securities</li>
                <li>To offer unbiased recommendation, disclosing the financial interests in recommended securities</li>
                <li>To provide research recommendation, based on analysis of publicly available information and known observations</li>
                <li>To conduct audit annually</li>
                <li>To ensure that all advertisements are in adherence to the provisions of the Advertisement Code for Research Analysts</li>
                <li>To maintain records of interactions, with all clients including prospective clients (prior to onboarding), where any conversation related to the research services has taken place</li>
              </ul>
            </div>
          </section>

          {/* Services Provided */}
          <section className="charter-section">
            <h2>C. Details of Services Provided to Investors (No Indicative Timelines)</h2>
            
            <div className="services-grid">
              <div className="service-category">
                <h3>Onboarding of Clients</h3>
                <ul>
                  <li>Sharing of terms and conditions of research services</li>
                  <li>Completing KYC of fee paying clients</li>
                </ul>
              </div>

              <div className="service-category">
                <h3>Disclosure to Clients</h3>
                <ul>
                  <li>To disclose, information that is material for the client to make an informed decision, including details of its business activity, disciplinary history, the terms and conditions of research services, details of associates, risks and conflicts of interest, if any</li>
                  <li>To disclose the extent of use of Artificial Intelligence tools in providing research services</li>
                  <li>To disclose, while distributing a third party research report, any material conflict of interest of such third party research provider or provide web address that directs a recipient to the relevant disclosures</li>
                  <li>To disclose any conflict of interest of the activities of providing research services with other activities of the research analyst</li>
                </ul>
              </div>

              <div className="service-category">
                <h3>Core Services</h3>
                <ul>
                  <li>To distribute research reports and recommendations to the clients without discrimination</li>
                  <li>To maintain confidentiality w.r.t publication of the research report until made available in the public domain</li>
                  <li>To respect data privacy rights of clients and take measures to protect unauthorized use of their confidential information</li>
                  <li>To disclose the timelines for the services provided by the research analyst to clients and ensure adherence to the said timelines</li>
                  <li>To provide clear guidance and adequate caution notice to clients when providing recommendations for dealing in complex and high-risk financial products/services</li>
                  <li>To treat all clients with honesty and integrity</li>
                  <li>To ensure confidentiality of information shared by clients unless such information is required to be provided in furtherance of discharging legal obligations or a client has provided specific consent to share such information</li>
                </ul>
              </div>
            </div>
          </section>

          {/* Grievance Redressal */}
          <section className="charter-section">
            <h2>D. Details of Grievance Redressal Mechanism and How to Access It</h2>
            
            <div className="grievance-info">
              <h3>1. Investor can lodge complaint/grievance against Research Analyst in the following ways:</h3>
              
              <div className="grievance-methods">
                <div className="method-box">
                  <h4>Mode of filing the complaint with research analyst</h4>
                  <p>In case of any grievance / complaint, an investor may approach the concerned Research Analyst who shall strive to redress the grievance immediately, but not later than <strong>21 days</strong> of the receipt of the grievance.</p>
                </div>

                <div className="method-box">
                  <h4>Mode of filing the complaint on SCORES or with Research Analyst Administration and Supervisory Body (RAASB)</h4>
                  <div className="scores-info">
                    <h5>i. SCORES 2.0</h5>
                    <p>A web based centralized grievance redressal system of SEBI for facilitating effective grievance redressal in time-bound manner</p>
                    <a href="https://scores.sebi.gov.in" target="_blank" rel="noopener noreferrer" className="scores-link">https://scores.sebi.gov.in</a>
                    
                    <div className="review-levels">
                      <h6>Two level review for complaint/grievance against Research Analyst:</h6>
                      <ul>
                        <li>First review done by designated body (RAASB)</li>
                        <li>Second review done by SEBI</li>
                      </ul>
                    </div>
                  </div>
                  
                  <div className="email-info">
                    <h5>ii. Email to designated email ID of RAASB</h5>
                  </div>
                </div>
              </div>

              <div className="smartodr-info">
                <h3>2. SMARTODR Platform</h3>
                <p>If the Investor is not satisfied with the resolution provided by the Market Participants, then the Investor has the option to file the complaint/ grievance on SMARTODR platform for its resolution through online conciliation or arbitration.</p>
                <a href="https://smartodr.in" target="_blank" rel="noopener noreferrer" className="smartodr-link">https://smartodr.in</a>
              </div>

              <div className="physical-complaint">
                <h3>Physical Complaints</h3>
                <p>With regard to physical complaints, investors may send their complaints to:</p>
                <div className="sebi-address">
                  <p><strong>Office of Investor Assistance and Education,</strong></p>
                  <p>Securities and Exchange Board of India,</p>
                  <p>SEBI Bhavan, Plot No. C4-A, 'G' Block,</p>
                  <p>Bandra-Kurla Complex, Bandra (E),</p>
                  <p>Mumbai - 400 051</p>
                </div>
              </div>
            </div>
          </section>

          {/* Rights of Investors */}
          <section className="charter-section">
            <h2>E. Rights of Investors</h2>
            <div className="rights-grid">
              <div className="right-item">
                <FaShieldAlt />
                <h4>Right to Privacy and Confidentiality</h4>
              </div>
              <div className="right-item">
                <FaEye />
                <h4>Right to Transparent Practices</h4>
              </div>
              <div className="right-item">
                <FaBalanceScale />
                <h4>Right to Fair and Equitable Treatment</h4>
              </div>
              <div className="right-item">
                <FaInfoCircle />
                <h4>Right to Adequate Information</h4>
              </div>
              <div className="right-item">
                <FaFileAlt />
                <h4>Right to Initial and Continuing Disclosure</h4>
              </div>
              <div className="right-item">
                <FaAd />
                <h4>Right to Fair & True Advertisement</h4>
              </div>
              <div className="right-item">
                <FaClock />
                <h4>Right to Awareness about Service Parameters and Turnaround Times</h4>
              </div>
              <div className="right-item">
                <FaVolumeUp />
                <h4>Right to be Heard and Satisfactory Grievance Redressal</h4>
              </div>
              <div className="right-item">
                <FaSignOutAlt />
                <h4>Right to Exit from Financial product or service</h4>
              </div>
              <div className="right-item">
                <FaExclamationTriangle />
                <h4>Right to receive clear guidance and caution notice</h4>
              </div>
              <div className="right-item">
                <FaWheelchair />
                <h4>Additional Rights to vulnerable consumers</h4>
              </div>
              <div className="right-item">
                <FaComment />
                <h4>Right to provide feedback on financial products and services</h4>
              </div>
              <div className="right-item">
                <FaGavel />
                <h4>Right against coercive, unfair, and one-sided clauses</h4>
              </div>
            </div>
          </section>

          {/* Expectations from Investors */}
          <section className="charter-section">
            <h2>F. Expectations from the Investors (Responsibilities of Investors)</h2>
            
            <div className="expectations-grid">
              <div className="dos-section">
                <h3>Do's</h3>
                <div className="expectation-list">
                  <div className="expectation-item">
                    <span className="expectation-number">i.</span>
                    <p>Always deal with SEBI registered Research Analyst.</p>
                  </div>
                  <div className="expectation-item">
                    <span className="expectation-number">ii.</span>
                    <p>Ensure that the Research Analyst has a valid registration certificate.</p>
                  </div>
                  <div className="expectation-item">
                    <span className="expectation-number">iii.</span>
                    <p>Check for SEBI registration number. Please refer to the list of all SEBI registered Research Analyst which is available on SEBI website in the following link:</p>
                    <a href="https://www.sebi.gov.in/sebiweb/other/OtherAction.do?doRecognisedFpi=yes&intmId=14" target="_blank" rel="noopener noreferrer" className="sebi-link">SEBI Registered Research Analysts List</a>
                  </div>
                  <div className="expectation-item">
                    <span className="expectation-number">iv.</span>
                    <p>Always pay attention towards disclosures made in the research reports before investing.</p>
                  </div>
                  <div className="expectation-item">
                    <span className="expectation-number">v.</span>
                    <p>Pay your Research Analyst through banking channels only and maintain duly signed receipts mentioning the details of your payments. You may make payment of fees through Centralized Fee Collection Mechanism (CeFCoM) of RAASB if research analyst has opted for the mechanism. (Applicable for fee paying clients only)</p>
                  </div>
                  <div className="expectation-item">
                    <span className="expectation-number">vi.</span>
                    <p>Before buying/ selling securities or applying in public offer, check for the research recommendation provided by your Research Analyst.</p>
                  </div>
                  <div className="expectation-item">
                    <span className="expectation-number">vii.</span>
                    <p>Ask all relevant questions and clear your doubts with your Research Analyst before acting on recommendation.</p>
                  </div>
                  <div className="expectation-item">
                    <span className="expectation-number">viii.</span>
                    <p>Seek clarifications and guidance on research recommendations from your Research Analyst, especially if it involves complex and high risk financial products and services.</p>
                  </div>
                  <div className="expectation-item">
                    <span className="expectation-number">ix.</span>
                    <p>Always be aware that you have the right to stop availing the service of a Research Analyst as per the terms of service agreed between you and your Research Analyst.</p>
                  </div>
                  <div className="expectation-item">
                    <span className="expectation-number">x.</span>
                    <p>Always be aware that you have the right to provide feedback to your Research Analyst in respect of the services received.</p>
                  </div>
                  <div className="expectation-item">
                    <span className="expectation-number">xi.</span>
                    <p>Always be aware that you will not be bound by any clause, prescribed by the research analyst, which is contravening any regulatory provisions.</p>
                  </div>
                  <div className="expectation-item">
                    <span className="expectation-number">xii.</span>
                    <p>Inform SEBI about Research Analyst offering assured or guaranteed returns.</p>
                  </div>
                </div>
              </div>

              <div className="donts-section">
                <h3>Don'ts</h3>
                <div className="expectation-list">
                  <div className="expectation-item">
                    <span className="expectation-number">i.</span>
                    <p>Do not provide funds for investment to the Research Analyst.</p>
                  </div>
                  <div className="expectation-item">
                    <span className="expectation-number">ii.</span>
                    <p>Don't fall prey to luring advertisements or market rumors.</p>
                  </div>
                  <div className="expectation-item">
                    <span className="expectation-number">iii.</span>
                    <p>Do not get attracted to limited period discount or other incentive, gifts, etc. offered by Research Analyst.</p>
                  </div>
                  <div className="expectation-item">
                    <span className="expectation-number">iv.</span>
                    <p>Do not share login credential and password of your trading, demat or bank accounts with the Research Analyst.</p>
                  </div>
                </div>
              </div>
            </div>
          </section>

          {/* Contact Information */}
          <section className="charter-section contact-section">
            <h2>Contact Information</h2>
            <div className="contact-grid">
              <div className="contact-item">
                <FaEnvelope />
                <h4>Email</h4>
                <p>mail.trillionstockresearch@gmail.com</p>
              </div>
              <div className="contact-item">
                <FaPhone />
                <h4>Phone</h4>
                <p>+91 9977555378</p>
              </div>
              <div className="contact-item">
                <FaCertificate />
                <h4>SEBI Registration</h4>
                <p>INH000020129</p>
              </div>
              <div className="contact-item">
                <FaMapMarkerAlt />
                <h4>Address</h4>
                <p>200 Sector A, Suryadev Nagar, Indore, Madhya Pradesh, 452012</p>
              </div>
            </div>
          </section>

        </div>
      </div>
      
      {/* Footer */}
      <Footer />
    </div>
  );
};

export default InvestorCharter_page;
